/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelClaimReason.ts                   *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/claim-reason";

export class AutogenModelClaimReason<RowType extends ModelRow> extends Endpoint<RowType, RowClaimReasonFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowClaimReason extends ModelRow<RowClaimReasonFields> {
	constructor(values?: Partial<RowClaimReasonFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowClaimReasonFields {
	company_id: string;
	descr: string;
	id: string;
	is_active: string;
}

